app.directive('singleSelect', function() {
	return {
		restrict: 'AE',
		scope: {
			selectValue: '='
		},
		controller: ["$scope", function($scope) {
			this.selectOption = function(value) {
				$scope.selectValue = ($scope.selectValue === value) ? undefined : value;
			};
		}]
	};
});

app.directive('selectOption', function() {
	return {
		restrict: 'AE',
		scope: {},
		require: '^singleSelect',
		link: function($scope, elem, attrs, vm) {
			$(elem).on('click', function() {
				vm.selectOption(attrs.selectOption);
			});
		}
	};
});